import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { EnumFile, SplunkEvent, SplunkLogLevel, SplunkSourceType } from '../models/SplunkEvent';
import { LocationService } from './location.service';
import { SplunkService } from './splunk.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private readonly router: Router,
    private readonly location: LocationService,
    private readonly splunkService: SplunkService
  ) {}

  navigateBasedOnRedirect(redirect: string | null | undefined = '/dashboard', extras: NavigationExtras = {}): void {
    redirect ??= '/dashboard';
    this.log(redirect, 'navigateBasedOnRedirect');
    this.router.navigateByUrl(redirect, {
      ...extras,
      replaceUrl: true,
    });
  }

  redirectToAmerenDotCom(slug?: string | null | undefined): void {
    if (slug) {
      const normalized = slug.toLowerCase();
      // We have a blocklist to simplify auth flow edge cases.
      if (normalized.includes('login') || normalized.includes('signincallback')) slug = undefined;
    }
    const baseUrl = `${environment.amerenUrl}/`;
    const url = slug ? `${environment.amerenUrl}/${slug}` : baseUrl;

    this.location.go(url);
  }

  private log(redirect: string, method: string) {
    this.splunkService
      .log(
        new SplunkEvent(
          EnumFile.NavigationService,
          {
            details: `redirect - ${redirect}`,
            flow: method,
          },
          SplunkSourceType.PMPUI,
          SplunkLogLevel.Info
        )
      )
      .subscribe();
  }
}
